import { ArrowUpDown, Calendar } from "lucide-react";
import SelectField from "../common/SelectField";
import SearchBar from "../common/SearchBar";
import "../../styles/common.css";
import "../../styles/driverHeader.css";

export default function TransactionHeader({ 
  total, search, onSearch, 
  typeFilter, onTypeChange, 
  dateFilter, onDateChange 
}) {
  
  return (
    <div className="pageHeader">
      <div className="headerTop">
        <div className="pageTitle">
          <h2>Transactions</h2>
          <span className="countBadge">{total}</span>
        </div>
      </div>

      <div className="filterActionsRow">
        <div className="selectorsGrid">
          <SelectField
            icon={ArrowUpDown}
            value={typeFilter}
            onChange={onTypeChange}
            options={[
                { label: "Tous les types", value: "all" },
                { label: "Recharges (+)", value: "incoming" },
                { label: "Retraits (-)", value: "outgoing" },
            ]}
          />

          <SelectField
            icon={Calendar}
            value={dateFilter}
            onChange={onDateChange}
            options={[
                { label: "Toutes les dates", value: "all" },
                { label: "Aujourd'hui", value: "today" },
                { label: "Cette semaine", value: "week" },
                { label: "Ce mois", value: "month" },
            ]}
          />
        </div>

        <div className="searchWrapper">
          <SearchBar
            value={search}
            onChange={onSearch}
            placeholder="Rechercher par nom, motif..."
          />
        </div>
      </div>
    </div>
  );
}